// Update stats to "Completed" to automatically remove the Sponsor section

export const researchProjects = [
{
  slug: 'postquantumcrypto',
  chapter: 'Do Quantum @ UMD',
  title: 'Post-Quantum Cryptography',
  industry: 'Cybersecurity',
  overview:
    'This project benchmarks and enhances post-quantum cryptographic schemes like Kyber, Dilithium, and McEliece for practical deployment on modern hardware.',
  details:
    'The team implements PQC algorithms using PQClean and benchmarks them against classical standards like AES-256 and RSA-2048 across modern hardware (e.g., AVX-512 CPUs, DPUs, GPUs). The research includes robustness testing under simulated quantum attacks using Qiskit, hardware-aware optimizations, and NIST randomness tests. Insights will help shape secure and efficient cryptographic practices for a quantum-ready future.',
  status: 'In Progress',
    group: '/groups/postquantumcrypto.JPG',
  people: [
    { name: 'Max Derezinski', image: '/headshots/MaxDerezinski.jpg', linkedin: 'https://www.linkedin.com/in/maximilian-derezinski-a86809335/' },
    { name: 'Attowla Kouadio', image: '/headshots/AttowlaKouadio.jpg', linkedin: 'https://www.linkedin.com/in/attowla-kouadio-37046728a/' },
    { name: 'Chaitra Bhumula', image: '/headshots/ChaitraBhumula.jpg', linkedin: 'https://www.linkedin.com/in/chaitra-bhumula-583695284/' },
    { name: 'Kashvi Tiwari', image: '/headshots/KashviTiwari.jpg', linkedin: 'https://www.linkedin.com/in/kashvi-tiwari/' },
    { name: 'Javin Ahuja', image: '/headshots/JavinAhuja.jpg', linkedin: 'https://www.linkedin.com/in/javin-ahuja-560100237/' },
  ],
  advisors: [
    { name: 'Wilson Smith', image: '/wilson.jpg', title: 'Research Advisor', linkedin: 'https://www.linkedin.com/in/wilson-smith-2421a51a2/' }
  ],
  orgs: [
    { name: 'Do Quantum @ UMD', image: '/umd-circle.png' },
    { name: 'Sponsor: None', image: '/question-mark.webp' }
  ],
  cost: '1,800',
  benefits: [
    'Robust implementations of NIST-standard PQC algorithms.',
    'Performance reports comparing emerging architectures (e.g., Bluefield, IPUs).',
    'Contributions toward national quantum cybersecurity standards.'
  ]
},
  {
    slug: 'sparseattention',
    chapter: 'Do Quantum @ UMD',
    title: 'Sparse Attention Optimization',
    industry: 'Natural Language Processing',
    overview:
        'This project explores whether quantum algorithms can optimize sparse attention in transformer models, aiming to improve NLP model efficiency and scalability.',
    details:
        'Sparse attention mechanisms reduce the computational cost of transformers by focusing only on relevant token interactions. This research integrates quantum techniques such as QFT, VQE, and QAOA to enhance sparse attention operations. Using frameworks like Qiskit and PennyLane, the team builds hybrid quantum-classical models and tests them on NLP benchmarks such as WikiText and GLUE. Results will assess model speed, accuracy, and quantum feasibility on real hardware (e.g., IonQ).',
    status: 'In Progress',
    group: '/groups/sparseattention.JPG',
    people: [
        { name: 'Mazin Nadaf', image: '/headshots/mazinnadaf.jpg', linkedin: 'https://www.linkedin.com/in/mazin-nadaf/' },
        { name: 'Nikita Arya', image: '/headshots/nikitaarya.jpg', linkedin: 'https://www.linkedin.com/in/nikitaaryaa/' },
        { name: 'Chris Polackal', image: '/headshots/chrispolackal.jpg', linkedin: 'https://www.linkedin.com/in/chris-polackal-483b76247' },
        { name: 'Duy Bui', image: '/headshots/duybui.jpg', linkedin: 'https://www.linkedin.com/in/duybui4' }
    ],
    advisors: [
        { name: 'Evren Yucekus-Kissane', image: '/evren.JPG', title: 'Research Advisor', linkedin: 'https://www.linkedin.com/in/evrenyk/' }
    ],
    orgs: [
        { name: 'Do Quantum @ UMD', image: '/umd-circle.png' },
        { name: 'Sponsor: None', image: '/question-mark.webp' }
    ],
    cost: '2,000',
    benefits: [
        'Co-authorship on quantum-AI publications.',
        'Pilot access to hybrid NLP tooling for large language model research.',
        'Invitations to present at quantum computing showcases.'
    ]
},
{
    slug: 'quantumfrauddetection',
    chapter: 'Do Quantum @ UMD',
    title: 'Financial Fraud Detection',
    industry: 'Finance',
    overview:
        'This project explores hybrid quantum-classical machine learning models to detect financial fraud more accurately, especially in data-scarce and imbalanced scenarios.',
    details:
        'By integrating quantum algorithms like QSVM, VQC, and QNN into classical pipelines (e.g., deep neural networks, XGBoost), this research aims to outperform traditional models in fraud detection. Techniques like quantum transfer learning and anomaly detection will be tested using real-world datasets, with performance assessed on metrics like precision, recall, and F1-score. Simulations will be run on IBM Qiskit and IonQ hardware.',
    status: 'In Progress',
    group: '/groups/quantumfrauddetection.jpg',
    people: [
        { name: 'Ramita Wiriyacoonkasem', image: '/headshots/RamitaWiriyacoonkasem.jpg', linkedin: 'https://www.linkedin.com/in/ramita-wiriyacoonkasem-27686b32b/' },
        { name: 'Samragyee Dhakal', image: '/headshots/SamragyeeDhakal.jpg', linkedin: 'https://www.linkedin.com/in/samragyee-dhakal/' },
        { name: 'Jolie Wu', image: '/headshots/JolieWu.jpg', linkedin: 'https://www.linkedin.com/in/jolie-wu-va89' },
        { name: 'Hanish Vadlamudi', image: '/headshots/HanishVadlamudi.jpg', linkedin: 'https://www.linkedin.com/in/hanish-vadlamudi/' },
        { name: 'Manoj Kumar Bashaboina', image: '/headshots/ManojBashaboina.jpg', linkedin: 'https://www.linkedin.com/in/manojkumarbashaboina/' },
    ],
    advisors: [
        { name: 'Evren Yucekus-Kissane', image: '/evren.JPG', title: 'Research Advisor', linkedin: 'https://www.linkedin.com/in/evrenyk/' },
    ],
    orgs: [
        { name: 'Do Quantum @ UMD', image: '/umd-circle.png' },
        { name: 'Sponsor: None', image: '/question-mark.webp' }
    ],
    cost: '1,500',
    benefits: [
        'Early access to hybrid quantum-classical fraud detection benchmarks.',
        'Opportunity to co-author research publications on QML in finance.',
        'Corporate exposure through demo days and stakeholder briefings.'
    ]
  },
{
  slug: 'quantumasphaltsimulation',
  chapter: 'Do Quantum @ UMD',
  title: 'Asphalt Strengthening',
  industry: 'Materials',
  overview:
    'This project uses quantum simulation to model molecular oxidation in asphalt, aiming to identify the chemical pathways that cause degradation and extend pavement lifespan.',
  details:
    'The team uses VQE circuits on NISQ devices to simulate oxidation barriers in sulfur- and nitrogen-containing polycyclic aromatic hydrocarbons, key molecules involved in asphalt aging. By applying tensor-factorization, symmetry tapering, and DMET techniques, the model reduces computational requirements while preserving chemical accuracy. The work benchmarks quantum-derived energy estimates against classical methods like CCSD(T) and assesses the real-world feasibility of near-term quantum hardware in materials science applications.',
  status: 'In Progress',
    group: '/groups/quantumasphaltsimulation.jpg',
  people: [
    { name: 'Aditya Sengupta', image: '/headshots/AdityaSengupta.jpg', linkedin: 'https://www.linkedin.com/in/adi-sen/' },
    { name: 'Trevor Kim', image: '/headshots/TrevorKim.jpg', linkedin: 'https://www.linkedin.com/in/trevor-kim-4b3949300/' },
    { name: 'Om Tailor', image: '/om.jpg', linkedin: 'https://www.linkedin.com/in/om-tailor-02b793226' },
    { name: 'Harshitha Gaddambachahalli Raghukumar', image: '/headshots/HarshithaRaghukumar.jpg', linkedin: 'https://www.linkedin.com/in/7harshithagr' }
  ],
  advisors: [
    { name: 'Evren Yucekus-Kissane', image: '/evren.JPG', title: 'Advisor', linkedin: 'https://www.linkedin.com/in/evrenyk/' }
  ],
  orgs: [
    { name: 'Do Quantum @ UMD', image: '/umd-circle.png' },
    { name: 'Sponsor: None', image: '/question-mark.webp' }
  ],
  cost: '3,000',
  benefits: [
    'Access to quantum-accelerated chemical simulations relevant to materials design.',
    'Potential industrial impact on $10–15B in annual U.S. infrastructure spending.',
    'Opportunity to demonstrate real-world NISQ utility in energy and infrastructure.'
  ]
},
{
  slug: 'quantumneurodiagnostics',
  chapter: 'Do Quantum @ UMD',
  title: 'Neurological Diagnostics',
  industry: 'Life Sciences',
  overview:
    'This project uses quantum-inspired autoencoding models to analyze noisy, high-dimensional brain imaging data, aiming to improve early diagnosis of neurological conditions like Alzheimer’s and Parkinson’s.',
  details:
    'Using fMRI and EEG datasets from small model organisms, the team develops hybrid neural mapping techniques combining classical autoencoders with quantum neural networks and quantum autoencoders via Qiskit and TensorFlow Quantum. These methods are benchmarked for accuracy, dimensionality reduction, and neuron-specific pattern recognition. The goal is to make complex brain data more interpretable and unlock earlier, more precise diagnostics through quantum-enhanced analysis.',
  status: 'In Progress',
    group: '/groups/quantumneurodiagnostics.jpg',
  people: [
    { name: 'Aryan Thakar', image: '/headshots/AryanThakar.jpg', linkedin: 'https://www.linkedin.com/in/aryanthakar/' },
    { name: 'Neal Rangarajan', image: '/headshots/NealRangarajan.jpg', linkedin: 'https://www.linkedin.com/in/neal-rangarajan/' },
    { name: 'Sukirat Bhatti', image: '/headshots/SukiratBhatti.jpg', linkedin: 'https://www.linkedin.com/in/sukirat-bhatti/' },
    { name: 'Viharika Penmetsa', image: '/headshots/ViharikaPenmetsa.jpg', linkedin: 'https://www.linkedin.com/in/trevor-kim-4b3949300/' }
  ],
  advisors: [
    { name: 'Om Tailor', image: '/om.jpg', title: 'Research Advisor', linkedin: 'https://www.linkedin.com/in/om-tailor-02b793226' },
    { name: 'Skylar Chan', image: '/headshots/SkylarChan.jpg', title: 'Research Advisor', linkedin: 'https://skylarchan.com/' }
  ],
  orgs: [
    { name: 'Do Quantum @ UMD', image: '/umd-circle.png' },
    { name: 'Sponsor: None', image: '/question-mark.webp' }
  ],
  cost: '2,250',
  benefits: [
    'Contribution to neuroscience and healthcare with quantum-enhanced diagnostic tools.',
    'First access to neural maps visualized via quantum dimensionality techniques.',
    'Potential clinical collaborations for neurological illness detection.'
  ]
},
{
  slug: 'snnquantumgates',
  chapter: 'Do Quantum @ UMD',
  title: 'Gate Pulse Modulation',
  industry: 'Hardware',
  overview:
    'This project explores the use of spiking neural networks (SNNs) to generate high-fidelity control pulses for superconducting quantum gates, aiming to improve adaptability and robustness in quantum systems.',
  details:
    'Using snnTorch and QuTiP, the team is developing and training SNN controllers to generate microwave pulse sequences for transmon qubits. These pulses will be benchmarked against traditional methods like GRAPE and reinforcement learning. The project simulates quantum dynamics and evaluates fidelity, pulse duration, and robustness under noise, targeting low-latency, energy-efficient implementations compatible with neuromorphic hardware.',
  status: 'In Progress',
    group: '/groups/snnquantumgates.JPG',
  people: [
    { name: 'Harshit Badjatia', image: '/headshots/HarshitBadjatia.jpg', linkedin: 'https://www.linkedin.com/in/harshit-badjatia-74a0a826b' },
    { name: 'Saurav Patel', image: '/headshots/SauravPatel.jpg', linkedin: 'https://www.linkedin.com/in/sauravpatel22/' },
    { name: 'David Shukhin', image: '/headshots/DavidShukhin.jpg', linkedin: 'https://www.linkedin.com/in/david-shukhin' },
    { name: 'Sriram Venkata Chakravartula Nallani', image: '/headshots/SriramNallani.jpg', linkedin: 'https://www.linkedin.com/in/sriram-nallan-chakravartula-3451b3291/' }
  ],
  advisors: [
    { name: 'Wilson Smith', image: '/wilson.jpg', title: 'Research Advisor', linkedin: 'https://www.linkedin.com/in/wilson-smith-2421a51a2/' }
  ],
  orgs: [
    { name: 'Do Quantum @ UMD', image: '/umd-circle.png' },
    { name: 'Sponsor: None', image: '/question-mark.webp' }
  ],
  cost: '2,200',
  benefits: [
    'Contribute to next-gen quantum control architectures.',
    'Showcase results in quantum computing and neuroscience crossover events.',
    'Potential for collaboration with neuromorphic hardware manufacturers.'
  ]
},
{
  slug: 'neutralatomcompiler',
  chapter: 'Do Quantum @ UMD',
  title: 'Neutral Atom Optimization',
  industry: 'Hardware',
  overview:
    'This project explores permutation algorithms and routing strategies for dynamically reconfigurable neutral atom quantum computers, reducing gate overhead and improving scalability.',
  details:
    'Neutral atom arrays allow mid-computation repositioning of qubits via optical tweezers, avoiding costly SWAP gates. This research simulates non-rectangular geometries like hexagonal or triangular lattices and tests combinatorial sorting methods such as bitonic and recursive partitioning. The goal is to formalize permutation overheads, propose routing optimizations, and improve fault tolerance through better compiler support for physical qubit layouts.',
  status: 'In Progress',
    group: '/groups/neutralatomcompiler.JPG',
  people: [
    { name: 'Zarif Gudikal', image: '/headshots/ZarifGudikal.jpg', linkedin: 'https://www.linkedin.com/in/zarif-gudikal-3b8518275/' },
    { name: 'David Li', image: '/headshots/DavidLi.jpg', linkedin: '' },
    { name: 'Robert Fasanello', image: '/headshots/RobertFasanello.jpg', linkedin: 'https://www.linkedin.com/in/robert-fasanello-3b3451329/' },
    { name: 'Saanvi Verma', image: '/headshots/SaanviVerma.jpg', linkedin: 'https://www.linkedin.com/in/shrita-verma/' },
    { name: 'Adithya Satheesh', image: '/headshots/AdithyaSatheesh.jpg', linkedin: 'https://www.linkedin.com/in/adithya-p-satheesh/' }
  ],
  advisors: [
    { name: 'Wilson Smith', image: '/wilson.jpg', title: 'Research Advisor', linkedin: 'https://www.linkedin.com/in/wilson-smith-2421a51a2/' }
  ],
  orgs: [
    { name: 'Do Quantum @ UMD', image: '/umd-circle.png' },
    { name: 'Sponsor: None', image: '/question-mark.webp' }
  ],
  cost: '1,600',
  benefits: [
    'Improved routing protocols for neutral atom architectures.',
    'Simulation results that guide physical compiler design.',
    'Potential for integration into future fault-tolerant quantum compilers.'
  ]
},
{
  slug: 'quantumattentiondotproduct',
  chapter: 'Do Quantum @ UMD',
  title: 'Attention Mechanism Optimization',
  industry: 'Natural Language Processing',
  overview:
    'This project introduces a hybrid transformer architecture where dot product attention is replaced by a quantum subroutine using the Swap Test and amplitude encoding.',
  details:
    'The team offloads the dot product computation between query and key vectors in a transformer to a quantum circuit using amplitude encoding and the Swap Test. Implemented via PennyLane and Qiskit, the model is benchmarked on NLP datasets (SST-2) using quantum simulators and real NISQ hardware (IonQ, IBM). Results will assess accuracy, latency, and noise resilience versus classical attention.',
  status: 'In Progress',
    group: '/groups/quantumattentiondotproduct.JPG',
  people: [
    { name: 'Mohe Edeen Abu Maizer', image: '/headshots/MoheMaizer.jpg', linkedin: 'https://www.linkedin.com/in/moheedeen/' },
    { name: 'Alhassan Nakib', image: '/headshots/AlhassanNakib.jpg', linkedin: 'https://www.linkedin.com/in/alhassan-nakib/' },
    { name: 'Inesh Tandon', image: '/headshots/IneshTandon.jpg', linkedin: 'https://www.linkedin.com/in/ineshtandy' },
    { name: 'Abhinav Singh', image: '/headshots/AbhinavSingh.jpg', linkedin: 'https://www.linkedin.com/in/abhinavsingh9714/' },
  ],
  advisors: [
    { name: 'Wilson Smith', image: '/wilson.jpg', title: 'Research Advisor', linkedin: 'https://www.linkedin.com/in/wilson-smith-2421a51a2/' }
  ],
  orgs: [
    { name: 'Do Quantum @ UMD', image: '/umd-circle.png' },
    { name: 'Sponsor: None', image: '/question-mark.webp' }
  ],
  cost: '1,750',
  benefits: [
    'Pilot deployment of quantum attention mechanisms for NLP.',
    'Benchmark results on NISQ hardware for quantum-classical integration.',
    'Authorship on transformer architecture research involving QPU hardware.'
  ]
},
{
  slug: 'dynamicpartitioningqml',
  chapter: 'Do Quantum @ UMD',
  title: 'Quantum-Classical Model Partitioning',
  industry: 'Machine Learning',
  overview:
    'This project develops a hybrid quantum-classical neural network that dynamically chooses between quantum or classical processing for each layer, improving efficiency in machine learning tasks.',
  details:
    'Using classical ML to predict whether a task should be offloaded to quantum or handled classically, the team designs a flexible hybrid system. It begins with static hybrid QNNs as baselines and trains decision models to route inputs accordingly. Benchmarks are performed using MNIST and weather datasets, evaluating gate count, inference time, and prediction accuracy on Qiskit and AerSimulator.',
  status: 'In Progress',
    group: '/groups/dynamicpartitioningqml.jpg',
  people: [
    { name: 'Kevin Lyons', image: '/headshots/KevinLyons.jpg', linkedin: '' },
    { name: 'Akarsh Jain', image: '/headshots/AkarshJain.jpg', linkedin: 'https://www.linkedin.com/in/akarsh-jain-27b52047/' },
    { name: 'Anushmita Dey', image: '/headshots/AnushmitaDey.jpg', linkedin: 'https://www.linkedin.com/in/anushmita-dey/' },
    { name: 'Kathy Chen', image: '/headshots/KathyChen.jpg', linkedin: 'https://www.linkedin.com/in/kathy-chen-swe/' },
    { name: 'Aaryan Patel', image: '/headshots/AaryanPatel.jpg', linkedin: 'https://www.linkedin.com/in/aaryankpatel/' },
    
  ],
  advisors: [
    { name: 'Om Tailor', image: '/om.jpg', title: 'Research Advisor', linkedin: 'https://www.linkedin.com/in/om-tailor-02b793226' }
  ],
  orgs: [
    { name: 'Do Quantum @ UMD', image: '/umd-circle.png' },
    { name: 'Sponsor: None', image: '/question-mark.webp' }
  ],
  cost: '2,300',
  benefits: [
    'First demonstration of task-specific quantum-classical partitioning.',
    'Co-authorship on adaptive hybrid QML models.',
    'Reusable framework for routing logic in variational quantum models.'
  ]
},
{
  slug: 'quantumcircuitoptimization',
  chapter: 'Do Quantum @ UMD',
  title: 'Qudit Mapping Circuit Optimization',
  industry: [ 'Machine Learning', 'Hardware' ],
  overview:
    'This project investigates how to optimize quantum circuits by leveraging machine learning techniques and mapping strategies from qubits to qudits to improve performance on NISQ-era hardware.',
  details:
    'The team explores using reinforcement learning agents to compress and optimize quantum circuits based on specific hardware constraints. It also evaluates translating qubit circuits to higher-dimensional qudit systems for hardware like trapped ion devices. The research assesses performance improvements via gate reduction, noise mitigation, and hardware-aware transpilation using Qiskit, Cirq, and classical ML frameworks like TensorFlow.',
  status: 'In Progress',
    group: '/groups/quantumcircuitoptimization.JPG',
  people: [
    { name: 'Dheeban Jeganathan', image: '/headshots/DheebanJeganathan.jpg', linkedin: 'https://www.linkedin.com/in/dheebhan-jeganathan-780760324/' },
    { name: 'Akshay Sharma', image: '/headshots/AkshaySharma.jpg', linkedin: 'https://www.linkedin.com/in/akshay-sharma06/' },
    { name: 'Aryan Bhupalam', image: '/headshots/AryanBhupalam.jpg', linkedin: 'https://www.linkedin.com/in/aryanbhupalam/' },
    { name: 'Simarbir Gill', image: '/headshots/SimarbirGill.jpg', linkedin: 'https://www.linkedin.com/in/simarbir-gill-492926313/' },
    { name: 'Varun Anand', image: '/headshots/VarunAnand.jpg', linkedin: 'https://www.linkedin.com/in/varun-anand-8198a7221/' },
    
  ],
  advisors: [
    { name: 'Vikram Kashyap', image: '/vik.png', title: 'Research Advisor', linkedin: 'https://vikramkashyap.com/' }
  ],
  orgs: [
    { name: 'Do Quantum @ UMD', image: '/umd-circle.png' },
    { name: 'Sponsor: None', image: '/question-mark.webp' }
  ],
  cost: '2,100',
  benefits: [
    'Optimized transpilation for NISQ devices via RL.',
    'Qudit-based circuit models for scalable simulations.',
    'Technical documentation and reusable codebase for compiler pipelines.'
  ]
},
{
  slug: 'usherblindnessgenomics',
  chapter: 'Do Quantum @ UMD',
  title: 'Rare Genetic Disease Blindness Cure',
  industry: 'Life Sciences',
  overview:
    'This project leverages quantum-enhanced genomic analysis to develop and validate repair strategies for blindness caused by Usher Syndrome Type 1, a rare genetic condition affecting vision and hearing.',
  details:
    'The team analyzes pathogenic variants in MYO7A and other implicated genes using quantum-inspired sequence alignment and mutation modeling. By applying quantum algorithms to accelerate homology search and variant prioritization, the research identifies high-confidence edit targets for CRISPR-Cas and base editing systems. Quantum-enhanced machine learning is used to simulate protein stability and splicing outcomes of proposed repairs. The ultimate goal is to co-design a personalized therapeutic path with researchers in ophthalmogenetics, using both classical and quantum pipelines to target specific patient mutations.',
  status: 'In Progress',
  group: '/groups/usherblindnessgenomics.png',
  people: [
    { name: 'Evren Yucekus-Kissane', image: '/evren.JPG', linkedin: 'https://www.linkedin.com/in/evrenyk/' },
    { name: 'Siri Duddella', image: '/siri.jpg', linkedin: 'https://www.linkedin.com/in/siriduddella/' },
    { name: 'Aryan Mehta', image: '/aryan.webp', linkedin: 'https://www.linkedin.com/in/aryanmehta7/' }
  ],
  advisors: [
  ],
  orgs: [
    { name: 'Do Quantum @ UMD', image: '/umd-circle.png' },
    { name: 'Sponsor: None', image: '/question-mark.webp' }
  ],
  cost: '3,500',
  benefits: [
    'Precision therapeutic proposals targeting MYO7A variants in Usher 1 patients.',
    'Quantum-enhanced variant analysis and repair simulation workflows.',
    'Clinical collaboration opportunities in ophthalmogenetics and personalized medicine.'
  ]
}

];
